import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
const Page2 = () =>{
    const [content, setContent] = useState('');

    const handleEditorChange = (content, editor) => {
    setContent(content);
    console.log('Content was updated:', content);
  };
    return(
        <div>
      <h2>WYSIWYG Editor</h2>
      <Editor
        apiKey="8mqivvsd6hsxja5q393v2cij4a8if9jnfu0n4d8rkgthixuu" 
        value={content}
        init={{
          height: 300,
          menubar: false,
          plugins: [
            'advlist autolink lists link image',
            'charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar:
            'undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help'
        }}
        onEditorChange={handleEditorChange}
      />
    </div>
    )
}

export default Page2






// ExampleTinyMCE.js


// const ExampleTinyMCE = () => {
  

//   return (
    
//   );
// };

// export default ExampleTinyMCE;
